import api from "../../../shared/api/client";

export async function getSettings() {
  const { data } = await api.get("/settings");
  return data;
}

export async function getVisibleSettings() {
  const { data } = await api.get("/settings", {
    params: { visible: true },
  });
  return data;
}

export async function getSidemenu() {
  const { data } = await api.get("/settings/sidemenu");
  return data;
}

/** App branding/version — settings_key `general` (legacy typo `gerneral` fallback). */
export async function getGeneralSetting() {
  try {
    const { data } = await api.get("/settings/general");
    return data;
  } catch (err) {
    if (err?.response?.status !== 404) throw err;
    const { data } = await api.get("/settings/gerneral");
    return data;
  }
}

export async function getTargetGroupsSetting() {
  const { data } = await api.get("/settings/targetgroups");
  return data;
}

export async function createSetting(body) {
  const { data } = await api.post("/settings", body);
  return data;
}

export async function updateSetting(body) {
  const { data } = await api.post("/settings", body);
  return data;
}

export async function updateSettingJson(settingsKey, settings_json) {
  const { data } = await api.put(`/settings/${settingsKey}`, {
    settings_json,
  });
  return data;
}

export async function deleteSetting(settingsKey) {
  const { data } = await api.delete(`/settings/${settingsKey}`);
  return data;
}
